import React, { useState, useEffect } from 'react';
import { Button, Typography, Dialog, DialogTitle, DialogContent, TextField, Grid, DialogActions, Autocomplete, Collapse, IconButton, Paper } from '@mui/material';
import { UserAuth } from '../context/AuthContext';
import { doc, getDoc, collection, addDoc,  getDocs, updateDoc, deleteDoc } from '@firebase/firestore';
import { db } from '../Firebase/firebase';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { SchoolArray } from '../Edit Form/schools';

const AwardPopUp = () => {
  const { user } = UserAuth();
  const [profileEditOpen, setProfileEditOpen] = useState(false);
  const [title, setTitle] = useState();
  const [level, setLevel] = useState();
  const [currentIndex, setCurrentIndex] = useState();
  const [expanded, setExpanded] = useState([]);
  const [deleteButtonVisible, setDeleteButtonVisible] = useState(false);
  const [formData, setFormData] = useState({
    titles: [],
    levels: [],
  });

  // Toggle expanded state for each essay
  const handleExpand = (index) => {
    const newExpanded = [...expanded];
    newExpanded[index] = !newExpanded[index];
    setExpanded(newExpanded);
  };

  useEffect(() => {
    // Fetch data for the user's essays
    const fetchData = async () => {
      try {
        const docRef = collection(doc(db, "profiles", user.uid), "Awards");
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          console.log("Document data:", docSnap.data());
          setFormData(docSnap.data());
        } else {
          console.log("No such document!");
        }
      } catch (error) {
        console.error("Error fetching document:", error);
      }
    };

    fetchData();
  }, [user]);

  // Handle profile edit open
  const editAward = (index) => {
    setTitle(formData.titles[index]);
    setLevel(formData.levels[index]);
    setCurrentIndex(index);
    setProfileEditOpen(true);
    setDeleteButtonVisible(true); // Show the delete button
  };

  useEffect(() => {
    // Fetch sub-collection data for the user's essays
    const subCollectionData = async () => {
      const studentDataRef = collection(doc(db, "profiles", user.uid), "Awards");

      const titles = [];
      const levels =[]

      try {
        const response = await getDocs(studentDataRef);
        response.docs.forEach((doc) => {
          const data = doc.data(); // Retrieve the data from the document
          titles.push(data.title);
          levels.push(data.level);
        });

        setFormData({ titles, levels });
        console.log(formData.prompts[1]);
      } catch (error) {
        console.log(error.message);
      }
    };

    subCollectionData();
  }, [user.uid]);

  // Handle profile edit open
  const handleProfileEditOpen = () => {
    setProfileEditOpen(true);
  };

  const handleProfileEditClose = () => {
    setProfileEditOpen(false);
  };

  // Handle profile save
  const handleProfileSave = async () => {
    if (!user) return;
  
    try {
      const userRef = collection(doc(db, "profiles", user.uid), "Awards");
      const newAward = {
        title: title,
        level: level,
      };
      await addDoc(userRef, newAward);
      setProfileEditOpen(false);
      console.log('Profile information updated successfully');
  
      // Add the new award to the existing form data preserving the order
      setFormData((prevState) => ({
        titles: [...prevState.titles, newAward.title],
        levels: [...prevState.levels, newAward.level],
      }));
    } catch (e) {
      console.log(e.message);
    }
  };
  
//new award
  const handleUploadNew = () => {
    setProfileEditOpen(true);
    setDeleteButtonVisible(false);
    setTitle();
    setLevel();
    setCurrentIndex();
  };


  // Handle profile save
  const handleUpdateSave = async () => {
    if (!user) return;

    try {
      const userRef = collection(doc(db, "profiles", user.uid), "Awards");
      const querySnapshot = await getDocs(userRef); 
      const docId = querySnapshot.docs[currentIndex].id;
      const essayRef = doc(userRef, docId);
          await updateDoc(essayRef, 
            {
              title: title,
              level: level,
            }
            );
      setProfileEditOpen(false);
      console.log('Profile information updated successfully');
    } catch (e) {
      console.log(e.message);
    }
  };

  // delete activity
  const handleDelete = async () => {
    if (!user) return;
  
    try {
      const userRef = collection(doc(db, "profiles", user.uid), "Awards");
      const querySnapshot = await getDocs(userRef); 
      const docId = querySnapshot.docs[currentIndex].id;
      await deleteDoc(doc(userRef, docId)); // Delete the document
      setProfileEditOpen(false);
      console.log('Profile information deleted successfully');
    } catch (e) {
      console.log(e.message);
    }
  };
  

  return (
    <div>
      <Grid container spacing={2} justifyContent="center"  
        sx={{
        minWidth: '70%',
        width: { xs: '100%', sm: '70%' }, // 100% on phone, 70% on computer
        margin: '0 auto', // Center horizontally
      }}>
        <Grid item xs={12} justifyContent="center" align="center">
          <Typography variant="h2">Awards</Typography>
          <Button onClick={handleUploadNew} className='border px-6 py-2 my-4'>
            Upload New Award
          </Button>
        </Grid>
        <Grid item xs={12}>
          {formData.titles.map((title, index) => (
            <Grid item xs={12} key={index}>
              <Paper variant="outlined" sx={{ p: 2 }}>
                <Grid container spacing={2} alignItems="center">
                <Grid item>
                      <Typography variant="h6">{index + 1}.</Typography>
                    </Grid>
                    <Grid item xs>
                      <Typography variant="body1" fontWeight="bold">{formData.levels[index]} Award</Typography>
                    </Grid>

                    <Grid item>
                      <IconButton
                        onClick={() => handleExpand(index)}
                        aria-expanded={expanded[index]}
                        aria-label="expand"
                      >
                        <ExpandMoreIcon />
                      </IconButton>
                    </Grid>
                    <Grid item>
                      <Grid container justifyContent="flex-end">
                        <Button onClick={() => editAward(index)}>Edit</Button>
                      </Grid>
                    </Grid>
                  </Grid>
                <Collapse in={expanded[index]} timeout="auto" unmountOnExit>
                  <div>
                    <Typography variant="body1" >{formData.titles[index]}</Typography>
                  </div>
                </Collapse>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Grid>

      <Dialog open={profileEditOpen} onClose={handleProfileEditClose} PaperProps={{ style: { minWidth: '70%' } }}>
        <DialogTitle>Upload Essay</DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Autocomplete
                onChange={(event, newValue) => {
                  setLevel(newValue)
                }}
                value={level}
                id="controllable-states-demo"
                options={["School", "State", "Region", "National"]}
                getOptionLabel={(option) => option}
                renderOption={(props, option, { selected }) => (
                  <li {...props}>
                    {option}
                  </li>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Level"
                  />
                )}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                required
                id="title"
                name="Title"
                label="Title"
                fullWidth
                multiline
                rows={2}
                value={title}
                onChange={(e) => {
                  setTitle(e.target.value)
                }}
                autoComplete="given-name"
                placeholder="Please enter the title of this award."
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleProfileEditClose}>
            Cancel
          </Button>
          {!deleteButtonVisible && (
          <Button onClick={handleProfileSave}>
            Save
          </Button>
          )}
          {deleteButtonVisible && (
          <Button onClick={handleUpdateSave}>
            Update
          </Button>
          )}
          {deleteButtonVisible && (
            <Button onClick={handleDelete} color="error">
              Delete
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default AwardPopUp;
